$(

    function(){
        
        if($('.view.page_tabs input[name="person-email_address"]').val() !== null && $('.view.page_tabs input[name="person-email_address"]').val() !== ""){
            $('.view.page_tabs input[name="person-email_address"]').attr('data-previous_email', $('.view.page_tabs input[name="person-email_address"]').val());
        }else{
            $('.view.page_tabs input[name="person-email_address"]').attr('data-previous_email', "");
        }
        verify_single_entry();
        function verify_single_entry(){
            if($('.view.page_tabs input[name="person-email_address"]').val() !== null && $('.view.page_tabs input[name="person-email_address"]').val() !== ""){  
                var job_id = "";
                
                if(typeof($('input[name="job_application-job_id"]').attr("value")) !== 'undefined'){
                    if($.isNumeric($('input[name="job_application-job_id"]').attr("value"))){
                        job_id = $('input[name="job_application-job_id"]').attr("value"); 
                    }
                }else if(typeof($('input[name="job-job_id"]').attr("value")) !== 'undefined'){
                    if($.isNumeric($('input[name="job-job_id"]').attr("value"))){
                        job_id = $('input[name="job-job_id"]').attr("value"); 
                    }
                } else{
                    const urlParams = new URLSearchParams(window.location.search);
                    if(urlParams.has('job-job_id')){
                        let jobID = urlParams.get('job-job_id');
                        if($.isNumeric(jobID)){
                            job_id = jobID;
                        }
                    }
                }
                
                if(job_id !== null && job_id !== "" && $.isNumeric(job_id)){
                    var valid = /^(([+-_A-Za-z0-9]|\.)+)+@(([-A-Za-z0-9]|\.)+)+$/.test($('.view.page_tabs input[name="person-email_address"]').val());
                    if(valid){
                        var url = "/applications/verify_single_entry?verify_email="+$('.view.page_tabs input[name="person-email_address"]').val()+"&job_id="+job_id;
                        $.ajax({
                            url: url
                        }).done(
                            function(data) {
                                if(data.includes("OK")){
                                    if(!$('.view.page_tabs input[name="person-email_address"]').hasClass("verified")){
                                        $('.view.page_tabs input[name="person-email_address"]').addClass("verified");
                                    }
                                    if($('.view.page_tabs input[name="person-email_address"]').parent().hasClass("has-error")){
                                        $('.view.page_tabs input[name="person-email_address"]').parent().removeClass("has-error");
                                    }
                                    if($('.view.page_tabs input[name="person-email_address"]').parent().find('.single_entry_error').length){
                                        $('.single_entry_error').remove();
                                    }
                                    
                                }else{
                                    if($('.view.page_tabs input[name="person-email_address"]').hasClass("verified")){
                                        $('.view.page_tabs input[name="person-email_address"]').removeClass("verified");
                                    }
                                    if(!$('.view.page_tabs input[name="person-email_address"]').parent().hasClass("has-error")){
                                        $('.view.page_tabs input[name="person-email_address"]').parent().addClass("has-error");
                                    }
                                    if(!$('.view.page_tabs input[name="person-email_address"]').parent().find('.single_entry_error').length){
                                        $('.view.page_tabs input[name="person-email_address"]').parent().append('<span class="single_entry_error" style="color:#a94442;">You\'ve already applied for this vacancy using this email address. Please double check your email address or go to \'My applications\' to see your progress.</span>');
                                    }
                                    $('.view.page_tabs input[name="person-email_address"]').trigger('focus');
                                }
                            }
                        );
                    }
                }
            }
        }
        
        $('.view.page_tabs input[name="person-email_address"]').on('focusout', function(){
            if($('.view.page_tabs input[name="person-email_address"]').val() !== null && $('.view.page_tabs input[name="person-email_address"]').val() !== "" && $('.view.page_tabs input[name="person-email_address"]').val() != $('.view.page_tabs input[name="person-email_address"]').attr("data-previous_email")){
                $('.view.page_tabs input[name="person-email_address"]').attr('data-previous_email', $('.view.page_tabs input[name="person-email_address"]').val());
                verify_single_entry();
            }
            if($('.view.page_tabs input[name="person-email_address"]').parent().find('.single_entry_error').length && !$('.view.page_tabs input[name="person-email_address"]').parent().hasClass("has-error")){
                $('.view.page_tabs input[name="person-email_address"]').parent().addClass("has-error");
            }
        });
        
        $('.manual-apply-button').on('click', function(){
            
            var form = new adapt.form($(this).parent('form').get(0));
            var $pages = $(this).parent('form').find('.form_page');

            var valid = true;
            
            for(var i = 0; i < $pages.length; i++){
                if (!form.is_page_valid($($pages.get(i)))) {
                    valid = false;
                }
            }

            // Check if a CV upload is in progress
            if ($('.uploadProgressBar:visible').length) {
                // CV upload is in progress, so mark as invalid as add a message.
                $('.cv_upload_area').addClass('has-error');
                $('.cv_upload_area').append('<div class="help-block wait-for-upload-message">Please wait for the CV upload to complete before submitting your application.</div>');
                valid = false;
            }
            
            if (valid){
                $(this).parents('form').trigger('submit');
            } else {
                if ($(".has-error").first().hasClass("form_page_section_field")) {
                    $('html, body').animate({
                        scrollTop: $(".has-error").first().parent().offset().top
                    }, 1000);                   
                } else {
                    $('html, body').animate({
                        scrollTop: $(".has-error").first().parent().parent().offset().top
                    }, 1000);                    
                }
                
                var that = $('.manual-apply-button-message');
                var text = $(that).html();
                $('.manual-apply-button-message').html("You've missed something! Scroll up to check");
                setTimeout(function(){
                    $(that).html(text);
                }, 5000);
            }
            
            return valid;
        });
        
        $('input[name="accept_statements"]').on('change', function(){
            if ($(this).is(':checked')) {
                $(this).parents('.view.form_page').find('[class="view btn btn-default control next pull-right"]').show("slow");
            } else {
                $(this).parents('.view.form_page').find('[class="view btn btn-default control next pull-right"]').hide("slow");
            }
        });
        
        $('select[name="job_application-has_management_experience"]').on('change', function(){
          if($("select[name='job_application-has_management_experience'] option:selected").text()=='No'){
            $(this).parents('.view.form_page').find('[class="view btn btn-default control next pull-right"]').hide("slow");
          } else {
            if ($("select[name='job_application-has_management_experience'] option:selected").text()=='Yes') {
                $(this).parents('.view.form_page').find('[class="view btn btn-default control next pull-right"]').show("slow");
            }
          }
        });

        $('input[name="person-date_of_birth"]').on('blur',function(){
            $(".age_error").remove();
            $(this).parent().removeClass('has-error');
            var date = $(this).datepicker("getDate");
            var today = new Date();
            if (date !== null) {
                var age = today.getFullYear() - date.getFullYear();
                var month = parseInt(today.getMonth(), 10) - parseInt(date.getMonth(), 10);
                if (month < 0 || (month === 0 && today.getDate() < date.getDate())) {
                    age--;
                }
                if (age < 17) {
                    $(this).parent().parent().css("height", "auto");
                    $(this).parent().after('<div class="age_error">ERROR! <br>You must be a minimum of 17 years of age to work for us.<br>Please confirm that you are at least 17 years of age and a school leaver.</div>');
                } else if (age>=17 && age<18) {
                    $(this).parent().parent().css("height","auto");
                    $(this).parent().after('<div class="age_error">WARNING! <br>You must be a minimum of 18 years of age to work for our bar, waiter/waitress, kitchen, maintenance and management teams.<br>If you are applying for any of this roles, please confirm that you are at least 18 years of age and a school leaver.</div>');
                }
            }
        });
        
        if($('input[name="role-ats_process_id"]').val()=='25'){
            $('div[data-form_page_section_id="336"]').detach();
            $('div[data-form_page_section_id="337"]').detach();
            $('div[data-form_page_section_id="338"]').detach();
            $('div[data-form_page_section_id="339"]').detach();
            $('select[name="person-cv"] option[value="No"]').detach();
            $('div[data-form_page_section_field_id="1348"]').css('display','none');
        }

        if($('.tabs_form').find('form').attr('action') == '/applications/login_or_register'){
            if(!$('.tabs_form').find($('input[name="person-person_id"]')).val() && $('.tabs_form').find($('input[name="actions"]')).val()){
                let formActions = $('.tabs_form').find($('input[name="actions"]')).val();
                let removeAction = "applications/complete";

                if( formActions.indexOf(",") !== -1){
                    let formActionsArray = formActions.split(",");

                    formActions = jQuery.grep(formActionsArray, function(value) {
                        return value != removeAction;
                    });
                }

                $('.tabs_form').find('input[name="actions"]').attr('value',formActions);
            }
        }
    }
);
